<!-- Do not change this file. -->

<template>
  <div
    :class="`alert
      alert-${type}
      border-${borderWidth} border-${type}
      text-start text-dark
      shadow-sm
      `"
    role="alert"
  >
    <span
      v-if="resolvedIconClass"
      class="position-absolute top-0 start-0 translate-middle badge rounded-circle p-0 d-flex align-items-center justify-content-center"
      :class="`bg-${type}`"
    >
      <div class="fs-6 p-1 bi" :class="resolvedIconClass"></div>
    </span>
    <div class="fw-bold mb-1" v-if="title">{{ title }}</div>
    <!-- v-html should never be used for student-authored data. -->
    <div v-html="content"></div>
    <!-- When student data is authored, use slots -->
    <slot></slot>
  </div>
</template>

<script>
/* Do not change this file. */

export default {
  name: "CustomAlert",
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String
    },
    content: {
      type: String
    },
    type: {
      type: String,
      required: false,
      default: "primary",
      validator: (value) => {
        return [
          "primary",
          "secondary",
          "warning",
          "danger",
          "info",
          "success"
        ].includes(value);
      }
    },
    borderWidth: {
      type: Number,
      required: false,
      default: 1,
      validator: (value) => {
        return [1, 2, 3, 4, 5].includes(value);
      }
    }
  },
  computed: {
    resolvedIconClass() {
      // If an icon prop is passed, it will override any defaults for the type
      if (this.icon) {
        return this.icon;
      }

      const base = "bi";
      const map = {
        primary: `${base}-info-circle`,
        secondary: `${base}-chat-left-text	`,
        warning: `${base}-exclamation-triangle`,
        danger: `${base}-exclamation-octagon`,
        info: `${base}-info-circle`,
        success: `${base}-check-circle`
      };

      return map[this.type] || ""; // No icon if no alert type is passed
    }
  }
};
</script>
